import * as Constants from '../constants';

const initialState = {
  errorMsg: '',
  selectedAddressId: '',
  addnewAddressView: false,
  editAddressDetails: '',
  paymentModeId: '',
  paymentModeSubId: '',
  optForWallet: true,
  orderType: 0,
  addressDetails: {
    contactName: '',
    typeDescription: '',
    flatNumber: '',
    streetName: '',
    cityName: '',
    pincode: '',
    contactNumber: ''
  },
  substitutionReasons: []
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case Constants.SET_ORDER_PARAMS:
      return Object.assign({}, state, action.data);
    case Constants.GET_PAYMENT_GATEWAYS_SUCCESS:
      return { ...state, paymentModeId: '' };
    case Constants.SET_ORDER_TYPE:
      return Object.assign({}, state, { orderType: action.data });
    case Constants.SAVE_SUBSTITUTION_REASONS:
      return { ...state, substitutionReasons: action.data };
    case Constants.CANCEL_ORDER:
      return { ...initialState }
    default:
      return { ...state };
  }
}
